
















import { defineComponent, ref } from "@vue/composition-api";

export default defineComponent({
  name: "BasePicture",
  props: {
    src: { type: String, required: true },
    webpSrcset: { type: String, default: "" },
    srcset: { type: String, default: "" },
    alt: { type: String, default: "" },
    width: { type: [Number, String], default: undefined },
    height: { type: [Number, String], default: undefined },
    loading: { type: String, default: "lazy" },
    decoding: { type: String, default: "async" },
  },
  setup() {
    const hasError = ref(false);

    function onError(e: Event) {
      if (hasError.value) return;
      hasError.value = true;

      const img = e.target as HTMLImageElement;
      img.src = "/img/content-no-preview.svg";
    }

    return {
      onError,
    };
  },
});
